/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface ListUsersResult
 */
export interface ListUsersResult {
    /**
     * ユーザー一覧
     * @type {Array<UserEntity>}
     * @memberof ListUsersResult
     */
    users: Array<UserEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListUsersResult
     */
    total: number;
}

/**
 * Check if a given object implements the ListUsersResult interface.
 */
export function instanceOfListUsersResult(value: object): value is ListUsersResult {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListUsersResultFromJSON(json: any): ListUsersResult {
    return ListUsersResultFromJSONTyped(json, false);
}

export function ListUsersResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUsersResult {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(UserEntityFromJSON)),
        'total': json['total'],
    };
}

export function ListUsersResultToJSON(json: any): ListUsersResult {
    return ListUsersResultToJSONTyped(json, false);
}

export function ListUsersResultToJSONTyped(value?: ListUsersResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(UserEntityToJSON)),
        'total': value['total'],
    };
}

